<div layout="row" layout-align="space-between center">
  <span [translate]="'notifications.refreshPagePrompt'"
    >New changes. Please, refresh page.</span
  >
  <button matTooltip="{{ 'global.refresh' | translate }}" mat-icon-button (click)="dismiss()">
    <mat-icon>refresh</mat-icon>
  </button>
</div>
